import { Box, Grid, IconButton, styled } from '@mui/material';

export const StyledGrid = styled(Grid)`
  padding: 20px;
`;

export const ProductVariationHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ProductVariationIcon = styled(IconButton)(
  ({ theme, $marginRight }) => `
    background-color: ${theme.palette.primary.contrastText};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    margin-right:${$marginRight ?? '20px'};
  `,
);
